import { action } from 'mobx';
import { HttpClient } from 'Mri.Web.Common';

export class UnsubscribeStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async unsubscribeDisplayAlert(userId: string, alertActionGuid: string) {
        await this.httpClient.delete(`/api/v1/unsubscribe`, { params: { userId, alertActionGuid } });
    }

    private readonly httpClient: HttpClient;
}
